<div class="cpp-add-prod" (window:resize)="onresize($event)">
  <h3 class="margin-t0">Add products to your order:</h3>

  <!--<p class="header-desc">
    Add products by searching for items below, selecting as many as you want by clicking on the checkbox, and clicking the “Add Product To Order” button at the bottom.
  </p>-->

  <div class="form-sec">
    <div class="row margin-sm-r0 margin-sm-l0">
      <div class="col-md-10 col-lg-12 smallPadRgt0">
        <app-cppfilter [filters]="filterTypeList" [isFromCppPage]="true" (SearchFilter)="filterProductGridData($event)" (ClearFilter)="clearGridData($event)"></app-cppfilter>
      </div>
    </div>
    <div class="row">
      <div class="text-center diclaimermsg col-12">{{this.disclaimerMessage}}</div>
    </div>
  </div>
  <div class="row margin-sm-r0 margin-sm-l0">
    <div class="col-md-12 tabBgColor padding-t10">
      <div *ngIf="isSortingEnable && plAccess" class="order-details">
        <div class="grower-column">
          <div class="grower-btns">
            <div class="btn-group" ngbDropdown placement="bottom-right" role="group" aria-label="sorting">
              <div class="grower-btns">
                <div class="btn-group" placement="bottom-right" role="group" aria-label="sorting">
                  <button type="button" class="btn btn-default" id="growerDealerSorting" ngbDropdownToggle>
                    <i class="icon-ico-order"></i>
                  </button>

                  <div ngbDropdownMenu aria-labelledby="growerDealerSorting" class="sortingDropdown">
                    <p>Sort By:</p>

                    <button class="dropdown-item" id="UP" (click)="sortData('UP')" [ngClass]="{'active' : selectedItem == 'UP'}">
                      Pricing
                      <i [ngClass]="{'fas fa-sort-down' : selectedItem == 'UP' && toggle}" aria-hidden="true"></i>
                      <i [ngClass]="{'fas fa-sort-up' : selectedItem == 'UP' && !toggle}" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <mat-tab-group (selectedTabChange)="onTabChange($event);" disableRipple [animationDuration]="'0ms'" class="matTabs prepayLandingTab">
        <mat-tab>
          <div class="col-md-2">
            <ng-template mat-tab-label>
              <div class="tab-head" data-testid="ddl-all-product-tab">
                <h4>
                  All Products
                </h4>
              </div>
            </ng-template>
          </div>
          <div class="tableContainer prodTableContainer table-mobile">
            <table mat-table [dataSource]="productAllDataSource" multiTemplateDataRows class="matTables productTable">
              <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
                <div *ngIf="column=='checkbox'">
                <th mat-header-cell *matHeaderCellDef class="checkBoxCol">&nbsp;</th>
          </div>
          <div *ngIf="column=='product'">
          <th mat-header-cell *matHeaderCellDef class="productNameBlock">Product Name</th>
    </div>
    <div *ngIf="column=='detail'"><th mat-header-cell *matHeaderCellDef class="package text-center">&nbsp;</th></div>
    <!--<div *ngIf="column=='productLine'"><th mat-header-cell *matHeaderCellDef class="pricingBlock text-center">Product Line</th></div>-->
    <div *ngIf="column=='quantity'"><th mat-header-cell *matHeaderCellDef class="package text-center">Quantity</th></div>
    <div *ngIf="column=='flashmsg'"><th mat-header-cell *matHeaderCellDef class="package text-center">&nbsp;</th></div>
    <div *ngIf="column=='packageSize'"><th mat-header-cell *matHeaderCellDef class="package text-center">Package Size</th></div>
    <td mat-cell *matCellDef="let element; let i = dataIndex;">
      <div *ngIf="column=='checkbox'" class="text-center CheckBoxCol d-flex" matTooltip="Select Product" [matTooltipPosition]="'above'">
        <div class="mobile-box">
          <mat-checkbox #SingleCheck [checked]="element.IsProductSelected"
                        (change)="selectProduct(element)"
                        class="custom-checkbox" [attr.data-testid]="'chk-all-product_'+element.itemNumber"></mat-checkbox>
        </div>
        <div class="mobile-box d-sm-block d-md-none" (click)="addRemoveFavoriteItem(element)">
          <span class="favIcon md-ml-20 xs-mt-0">
            <i *ngIf="!element.isFavorite" [attr.data-testid]="'ddl-specific-non-favourite-icon-model_'+element.itemNumber" class="far fa-star"></i>
            <i *ngIf="element.isFavorite" [attr.data-testid]="'ddl-specific-favourite-icon-model_'+element.itemNumber" class="fas fa-star"></i>
          </span>
        </div>
      </div>

      <div *ngIf="column=='product'" class="order-info-outer dd-flex">
        <div class="favProduct favIcon d-none d-sm-none d-md-block" [ngClass]="{marginttop22 : ((element.yourPrice) && (plAccess==true) && (element.yourPrice!='') && (element.yourPrice!=null) && (element.yourPrice!=0))}">
          <span (click)="addRemoveFavoriteItem(element)" [attr.data-testid]="'btn-all-tab-add-remove_'+element.itemNumber">
            <i *ngIf="!element.isFavorite" class="far fa-star"></i>
            <i *ngIf="element.isFavorite" class="fas fa-star"></i>
          </span>
        </div>
        <div class="d-block d-sm-block d-md-none xs-large-font">Product</div>
        <div class="order-info xs-large-font">
          <span style="width: 85%;">
            <p>{{element.itemVendorName}}</p>
            <p class="grower-name" [attr.data-testid]="'lbl-all-tab-item_'+element.itemNumber">{{element.itemDescription}}</p>
            <p><span *ngIf="element.yourPrice && plAccess==true && element.yourPrice!='' && element.yourPrice!=null && element.yourPrice!=0" class="growerUnit">${{element.yourPrice | number:'1.4-4'}}/{{element.pricingUnitOfMeasure}}</span></p>
            <p><span *ngIf="element.paymentTerms && plAccess==true" class="paymentTerm">{{element.paymentTerms}}</span></p>
          </span>
          <span *ngIf="element.isBIO" style=" vertical-align: top; margin-top: 10px;">
            <img src="../../../../../assets/icon/svg/WU_Bioverified_Green.png" matTooltip="Winfield United Bioverified" [matTooltipPosition]="'above'" />
          </span>
        </div>
        <span class="favIcon position-relative" *ngIf="element.warningMessage">
          <i class="warning-icon" mat-raised-button
             matTooltip="{{element.warningMessage}}"
             [matTooltipPosition]="'above'" matTooltipClass='red-tooltip'></i>
        </span>

      </div>
      <div *ngIf="column=='flashmsg'">
        <div [ngClass]="{'order-info-outer-flash-message' :((element.itemFlashMsgDesc!='') && (element.itemFlashMsgDesc!=null))}" *ngIf="element.itemFlashMsgDesc!=''">
          {{element.itemFlashMsgDesc}}
        </div>
      </div>
      <div *ngIf="column=='quantity'" class="measureUnit largeTableTxt text-center largeTableTxt mobile-col-set">
        <div class="d-block d-sm-block d-md-none">Quantity</div>
        <div class="ml-5 ml-md-0 text-center">
          <button class="plus-minus-btn minusBtn" (click)="cppUnitChange('decrease',element)" [attr.data-testid]="'btn-specific-minus_'+element.itemNumber+'_'+element.rowId"> - </button>
          <!-- [ngClass]="{'invalid-txt': (element.quantity<=0 || element.quantity=='')}" -->
          <input *ngIf="!element.allowDecimal" type="text" class="geu-txt decimal-txt unitsText largeTableTxt" (keyup)="quantityTextChange(element)" [(ngModel)]="element.quantity" maxlength="10" NumbersOnly [attr.data-testid]="'txt-specific-qty_'+element.itemNumber+'_'+element.rowId" />
          <input *ngIf="element.allowDecimal" type="text" class="geu-txt decimal-txt unitsText largeTableTxt" (keyup)="quantityTextChange(element)" [(ngModel)]="element.quantity" maxlength="10" NumbersOnly [allowDecimals]="true" [attr.data-testid]="'txt-specific-qty_'+element.itemNumber+'_'+element.rowId" />
          <button class="plus-minus-btn plusBtn" (click)="cppUnitChange('increase',element)" [attr.data-testid]="'btn-specific-plus_'+element.itemNumber+'_'+element.rowId"> + </button>
        </div>
      </div>
      <div *ngIf="column=='detail'" class="showHideDetails text-center md-pt-0" (click)="showProductDetails(element);">
        <a>{{element.isSelected ? 'Hide Product Details':'View Product Details' }}</a>
      </div>
      <!--<div *ngIf="column=='productLine'" class="measureUnit largeTableTxt text-center  largeTableTxt mobile-col-set">
    <div class="d-block d-sm-block d-md-none">Product Line</div>
    <div class="m-center">{{element.productLine}}</div>
  </div>-->
      <div *ngIf="column=='packageSize'" class="measureUnit largeTableTxt text-center largeTableTxt mobile-col-set">
        <div class="d-block d-sm-block d-md-none">Package Size</div>
        <div class="m-center"> {{element.packageSize}}</div>
      </div>
    </td>
    </ng-container>

    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
    <ng-container matColumnDef="expandedDetail">
      <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="displayedColumns.length" [style.display]="element.isSelected ? 'table-cell' : 'none'">
        <div>
          <div class="cpp-prod-info mobile-nested-table">
            <table style="width:100%" class="m-0">
              <thead>
                <tr>
                  <th width="10%" class="text-left">Item # </th>
                  <th width="13%"> GTIN </th>
                  <th width="13%"> Product Line </th>
                  <th width="20%"> Active Ingredients </th>
                  <!--<th width="10%"> National Price </th>-->
                  <th width="13%"> Pallet Quantity </th>
                  <th width="13%"> Restricted Use </th>
                  <th width="13%"> Non-Returnable </th>
                </tr>
              </thead>
              <tbody>
                <tr class="">
                  <th width="10%" class="d-block d-sm-block d-md-none">Item # </th>

                  <td width="10%" class="text-left"><p>{{element.itemNumber}}</p> </td>
                  <th width="13%" class="d-block d-sm-block d-md-none"> GTIN </th>
                  <td width="13%"><p>{{element.gtin}}</p></td>
                  <th width="13%" class="d-block d-sm-block d-md-none"> Product Line </th>

                  <td width="13%"> <p>{{element.productLine}}</p> </td>
                  <th width="20%" class="d-block d-sm-block d-md-none"> Active Ingredients </th>
                  <td width="20%"><p>{{element.activeIngredient}}</p> </td>
                  <!--<th width="10%" class="d-block d-sm-block d-md-none"> National Price </th>

                        <td width="10%"> <p> {{element.price | number:'1.4-4'}}</p> </td>-->
                  <th width="13%" class="d-block d-sm-block d-md-none"> Pallet Quantity </th>
                  <td width="13%"><p>{{element.palletQuantity | number:'1.4-4'}}</p> </td>
                  <th width="13%" class="d-block d-sm-block d-md-none"> Restricted Use </th>

                  <td width="13%"><p>{{element.restrictedUse}}</p> </td>
                  <th width="13%" class="d-block d-sm-block d-md-none"> Non-Returnable </th>
                  <td width="13%"><div [ngClass]="{'oval-shape returnable':( element.returnable ==='X')}"><p>{{element.returnable}}</p></div></td>
                </tr>
                <tr *ngIf="element.warningMessage">
                  <td mat-cell class="product-details" colspan="8">
                    <div class="inline-error red-inline-error m-0">
                      <div class="row">
                        <div class="error-msg">{{element.warningMessage}}</div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
    <tr mat-row *matRowDef="let element; columns: displayedColumns;"
        class="example-element-row"
        [class.example-expanded-row]="expandedElement === element"
        (click)="expandedElement = expandedElement === element ? null : element"></tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
    </table>
  </div>
  </mat-tab>

  <mat-tab>
    <div class="col-md-2">
      <ng-template mat-tab-label>
        <div class="tab-head" data-testid="favourite-product-tab">
          <h4>
            Favorite Products
          </h4>
        </div>
      </ng-template>
    </div>
    <div class="tableContainer prodTableContainer favProdTableContainer table-mobile" (window:resize)="onresize($event)">
      <table mat-table [dataSource]="favProductDataSource" multiTemplateDataRows class="matTables productTable">
        <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
          <div *ngIf="column=='checkbox'">
          <th mat-header-cell *matHeaderCellDef class="checkBoxCol">&nbsp;</th>
    </div>
    <div *ngIf="column=='product'">
    <th mat-header-cell *matHeaderCellDef class="productNameBlock">Product Name</th>
</div>
<div *ngIf="column=='detail'"><th mat-header-cell *matHeaderCellDef class="showHideBlock text-center">&nbsp;</th></div>
<!--<div *ngIf="column=='productLine'"><th mat-header-cell *matHeaderCellDef class="productLineBlock text-center">Product Line</th></div>-->
<div *ngIf="column=='quantity'"><th mat-header-cell *matHeaderCellDef class="package text-center">Quantity</th></div>
<div *ngIf="column=='flashmsg'"><th mat-header-cell *matHeaderCellDef class="package text-center">&nbsp;</th></div>
<div *ngIf="column=='packageSize'"><th mat-header-cell *matHeaderCellDef class="packageSizeBlock text-center">Package Size</th></div>

<td mat-cell *matCellDef="let element; let i = dataIndex;">
  <div *ngIf="column=='checkbox'" class="text-center CheckBoxCol  d-flex" matTooltip="Select Product" [matTooltipPosition]="'above'">
    <div class="mobile-box">
      <mat-checkbox #SingleCheck [checked]="element.IsProductSelected"
                    (change)="selectProduct(element)"
                    class="custom-checkbox" [attr.data-testid]="'chk-favourite-product_'+element.itemNumber"></mat-checkbox>
    </div>
    <div class="mobile-box d-sm-block d-md-none" (click)="addRemoveFavoriteItem(element)">
      <span class="favIcon md-ml-20 xs-mt-0">
        <i *ngIf="!element.isFavorite" class="far fa-star"></i>
        <i *ngIf="element.isFavorite" [attr.data-testid]="'ddl-favourite-tab-favourite-icon-model_'+element.itemNumber" class="fas fa-star"></i>
      </span>
    </div>
  </div>

  <div *ngIf="column=='product'" class="order-info-outer dd-flex">
    <span (click)="addRemoveFavoriteItem(element)" class="favIcon d-none d-sm-none d-md-block" [attr.data-testid]="'btn-favourite-tab-add-remove_'+element.itemNumber">
      <i *ngIf="!element.isFavorite" class="far fa-star"></i>
      <i *ngIf="element.isFavorite" class="fas fa-star"></i>
    </span>
    <div class="d-block d-sm-block d-md-none xs-large-font">Product</div>
    <div class="order-info xs-large-font">
      <span style="width: 85%;">
        <p>{{element.itemVendorName}}</p>
        <p class="grower-name" [attr.data-testid]="'lbl-favourite-tab-item_'+element.itemNumber">{{element.itemDescription}}</p>
        <p><span *ngIf="element.yourPrice && plAccess==true && element.yourPrice!='' && element.yourPrice!=null && element.yourPrice!=0" class="growerUnit">${{element.yourPrice | number:'1.4-4'}}/{{element.pricingUnitOfMeasure}}</span></p>
        <p><span *ngIf="element.paymentTerms && plAccess==true" class="paymentTerm">{{element.paymentTerms}}</span></p>
      </span>
      <span *ngIf="element.isBIO" style=" vertical-align: top; margin-top: 10px;">
        <img src="../../../../../assets/icon/svg/WU_Bioverified_Green.png" matTooltip="Winfield United Bioverified" [matTooltipPosition]="'above'" />
      </span>
    </div>

    <span class="favIcon position-relative" *ngIf="element.warningMessage">
      <i class="warning-icon" mat-raised-button
         matTooltip="{{element.warningMessage}}"
         [matTooltipPosition]="'above'" matTooltipClass='red-tooltip'></i>
    </span>

    <!--<p class="order-info grower-name">{{element.itemDescription}}</p>-->
  </div>
  <div *ngIf="column=='flashmsg'">
    <div [ngClass]="{'order-info-outer-flash-message' :((element.itemFlashMsgDesc!='') && (element.itemFlashMsgDesc!=null))}" *ngIf="element.itemFlashMsgDesc!=''">
      {{element.itemFlashMsgDesc}}
    </div>
  </div>
  <div *ngIf="column=='quantity'" class="measureUnit largeTableTxt text-center largeTableTxt mobile-col-set">
    <div class="d-block d-sm-block d-md-none">Quantity</div>
    <div class="ml-5 ml-md-0 text-center">
      <button class="plus-minus-btn minusBtn" (click)="cppUnitChange('decrease',element)" [attr.data-testid]="'btn-specific-minus_'+element.itemNumber+'_'+element.rowId"> - </button>
      <input *ngIf="!element.allowDecimal" type="text" class="geu-txt decimal-txt unitsText largeTableTxt" (keyup)="quantityTextChange(element)" [(ngModel)]="element.quantity" maxlength="10" NumbersOnly [attr.data-testid]="'txt-specific-qty_'+element.itemNumber+'_'+element.rowId" />
      <input *ngIf="element.allowDecimal" type="text" class="geu-txt decimal-txt unitsText largeTableTxt" (keyup)="quantityTextChange(element)" [(ngModel)]="element.quantity" maxlength="10" NumbersOnly [allowDecimals]="true" [attr.data-testid]="'txt-specific-qty_'+element.itemNumber+'_'+element.rowId" />
      <button class="plus-minus-btn plusBtn" (click)="cppUnitChange('increase',element)" [attr.data-testid]="'btn-specific-plus_'+element.itemNumber+'_'+element.rowId"> + </button>
    </div>
  </div>
  <div *ngIf="column=='detail'">
    <div class="showHideDetails text-center  md-pt-0" (click)="showProductDetails(element);">
      <a>{{element.isSelected ? 'Hide Product Details':'View Product Details' }}</a>
    </div>

    <!--<a href="javascript:void(0)" (click)="showProductDetails(element);">{{element.isSelected ? 'Hide Detail':'Show Detail' }}</a>-->
  </div>

  <!--<div *ngIf="column=='pricingUOM'" class="text-center">
    <p> {{element.pricingUnitOfMeasure}} </p>
  </div>

  <div *ngIf="column=='pricePerUnitPricingUOM'" class="measureUnit text-center">
    <p> {{element.pricePerUnit | currency :'USD'}} </p>
  </div>-->
  <!--<div *ngIf="column=='productLine'" class="measureUnit largeTableTxt text-center  largeTableTxt mobile-col-set">
    <div class="d-block d-sm-block d-md-none">Product Line</div>
    <div class="m-center">{{element.productLine}}</div>
  </div>-->
  <div *ngIf="column=='packageSize'" class="measureUnit largeTableTxt text-center largeTableTxt mobile-col-set">
    <div class="d-block d-sm-block d-md-none">Package Size</div>
    <div class="m-center"> {{element.packageSize}}</div>
  </div>

  <!--<div *ngIf="column=='orderUOM'" class="measureUnit text-center">
    <p> {{element.uom}} </p>
  </div>

  <div *ngIf="column=='pricePerUnitOrderUOM'" class="measureUnit text-center">
    <p> {{element.price | currency :'USD'}} </p>
  </div>-->
</td>
              </ng-container>

<!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
<ng-container matColumnDef="expandedDetail">
  <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="displayedColumns.length" [style.display]="element.isSelected ? 'table-cell' : 'none'">
    <div>
      <div class="cpp-prod-info mobile-nested-table">
        <table style="width:100%">
          <thead>
            <tr>
              <th class="text-left" width="10%"> Item # </th>
              <th width="10%"> GTIN </th>
              <th width="15%"> Product Line </th>
              <th width="25%"> Active Ingredients </th>
              <!--<th width="10%"> National Price </th>-->
              <th width="11%"> Pallet Quantity </th>
              <th width="10%"> Restricted Use </th>
              <th width="10%"> Non-Returnable </th>
            </tr>
          </thead>
          <tbody>
            <tr class="">
              <th width="10%" class="d-block d-sm-block d-md-none">Item # </th>

              <td class="text-left" width="11%"> <p>{{element.itemNumber}}</p> </td>
              <th width="10%" class="d-block d-sm-block d-md-none"> GTIN </th>
              <td width="10%"> <p>{{element.gtin}}</p> </td>
              <th width="15%" class="d-block d-sm-block d-md-none"> Product Line </th>

              <td width="15%"> <p>{{element.productLine}}</p> </td>
              <th width="25%" class="d-block d-sm-block d-md-none"> Active Ingredients </th>
              <td width="25%"> <p>{{element.activeIngredient}}</p> </td>
              <!--<th width="10%" class="d-block d-sm-block d-md-none"> National Price </th>

              <td width="10%"> <p> {{element.price | number:'1.4-4'}}</p></td>-->
              <th width="11%" class="d-block d-sm-block d-md-none"> Pallet Quantity </th>
              <td width="11%"> <p>{{element.palletQuantity | number:'1.4-4'}}</p> </td>
              <th width="10%" class="d-block d-sm-block d-md-none"> Restricted Use </th>

              <td width="10%"> <p>{{element.restrictedUse}}</p> </td>
              <th width="6%" class="d-block d-sm-block d-md-none"> Non-Returnable </th>
              <td width="6%"><div [ngClass]="{'oval-shape returnable':( element.returnable ==='X')}"><p>{{element.returnable}}</p></div></td>
            </tr>
            <tr *ngIf="element.warningMessage">
              <td mat-cell class="product-details" colspan="8">
                <div class="inline-error red-inline-error m-0">
                  <div class="row">
                    <div class="error-msg">{{element.warningMessage}}</div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </td>
</ng-container>
<tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
<tr mat-row *matRowDef="let element; columns: displayedColumns;"
    class="example-element-row"
    [class.example-expanded-row]="expandedElement === element"
    (click)="expandedElement = expandedElement === element ? null : element"></tr>
<tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
            </table>
          </div>

<ng-template mat-tab-label>
  <div class="tab-head" data-testid="favourite-product-tab">
    <div class="order-details col-2">
      <div *ngIf="isSortingEnable && plAccess" class="grower-column" style=" border: none !important;">
        <div class="grower-btns justify-content-end">
          <div class="btn-group" ngbDropdown placement="bottom-right" role="group" aria-label="sorting">
            <button type="button" class="btn btn-default" id="growerDealerSorting" ngbDropdownToggle>
              <i class="icon-ico-order"></i>
            </button>
            <div ngbDropdownMenu aria-labelledby="growerDealerSorting" class="sortingDropdown">
              <p>Sort By:</p>
              <button class="dropdown-item" id="UP" (click)="sortData('UP')" [ngClass]="{'active' : selectedItem == 'UP'}">
                Pricing
                <i [ngClass]="{'fas fa-sort-down' : selectedItem == 'UP' && toggle}" aria-hidden="true"></i>
                <i [ngClass]="{'fas fa-sort-up' : selectedItem == 'UP' && !toggle}" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
</mat-tab>
<div class="col-md-2">
  <ng-template mat-tab-label>
    <div class="tab-head" data-testid="favourite-product-tab">
      <h4>
        Favorite Products
      </h4>
    </div>
  </ng-template>
</div>
      </mat-tab-group>
    </div>
  </div>
</div>
<div class="row add-order-sec margin-l0 margin-r0">
  <div class="col-md-6 xs-pl-0 xs-pr-0">
    <button data-testid="ddl-add-cpp-product-model" mat-raised-button class="btns xs-button xs-full-width" color="primary" [disabled]="isProductNotAdded" (click)="addSelectedProductToOrder()">Add Product to Order</button>
  </div>
  <div class="col-md-6 text-right xs-text-center xs-mt-10 md-mt-0">
    <span class="count  d-none d-sm-none d-md-block">{{selectedProductList.length}} selected</span>
    <div class="d-flex justify-content-center align-items-center d-block d-sm-block d-md-none count-text">
      <span class="round-icon xs-mr-15">{{selectedProductList.length}} </span>
      <span>selected</span>
    </div>
  </div>
</div>
